// Currently no cookies are needed, but for the upcoming AB test we will need it again to test different page sizes against each other
// To have less adjustments now, and later on, we will just leave the parameter for now
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getDefaultPageSize = (cookies: Record<string, string>) =>
  // actual visible card count is 74 when including the search buddy teaser cards
  // changing the values back to 72 to match the results without infinite scrolling
  // to have a better comparison in the AB tests
  72;
